import React from 'react';
import './TestComponent.css'
import { NavLink,Route, Switch } from 'react-router-dom';
import InvalidPath from '../NotFound';
import ContextComponent from '../MainContentArea/ContextComponant';
import StateManaGementComponent from '../MainContentArea/StateManaGementComponent';
import CommunicationBetweenTwoComponent from '../MainContentArea/CommunicationBetweenTwoComponent';
import {ObjectLoopingComponent} from '../MainContentArea/ObjectLoopingComponent';
import ListofPracticeComponent from '../MainContentArea/ListofPracticeComponent';
import {AddMyPractice} from '../MainContentArea/AddMyPractice';
import FormEXComponent from '../MainContentArea/FormComponent';
import LiftingStateExampleCompo from '../MainContentArea/LiftingStateExampleCompo';
import LeranReactrefCompoent from '../MainContentArea/LeranReactrefCompoent';
import PlayVideo from '../MainContentArea/PlayVideo';
import ForwardRefComponent from '../MainContentArea/ForwardRefComponent';
import AdminDashboard from '../MainContentArea/HODExampleComponent'
const employees = [
    {Id:101,Name:'Abhinav',Location:'Bangalore',Salary:12345},  
    {Id:102,Name:'Abhishek',Location:'Chennai',Salary:23456},  
    {Id:103,Name:'Ajay',Location:'Bangalore',Salary:34567}  
  ];
function TestComponent(){
    return(
        <div className="TestRow-main">
        <div className="TestNav">
         <NavLink to={"/Personal/Practice/StateManagemnt"}>Statemanagement</NavLink><br/>
         <NavLink to={"/Personal/Practice/ComponentCommunication"}>ComponentInteraction</NavLink><br/>
         <NavLink to={"/Personal/Practice/Context"}>Context</NavLink><br/>      
         <NavLink to={"/Personal/Practice/LoopingThroughData"}>LoopingThroughObject</NavLink><br/>
         <NavLink to={"/Personal/Practice/ServiceCalling"}>ServicesCall</NavLink><br/>   
         <NavLink to={"/Personal/Practice/AddMyPractice"}>AddMyPractice</NavLink><br/> 
         <NavLink to={"/Personal/Practice/Forms"}>FormExample</NavLink><br/> 
         <NavLink to={"/Personal/Practice/LiftStateUp"}>LiftingState</NavLink><br/> 
         <NavLink to={"/Personal/Practice/LearnReactref"}>Ref</NavLink><br/> 
         <NavLink to={"/Personal/Practice/PlayVideo"}>Ref2</NavLink><br/> 
         <NavLink to={"/Personal/Practice/ForwardRef"}>Ref3</NavLink><br/> 
         <NavLink to={"/Personal/Practice/HODexample"}>HODexample</NavLink><br/> 
         
        </div>   
        <div className="Content">
        <Switch>             
             <Route exact path="/Personal/" component={TestMainComponent} ></Route> 
             <Route exact path="/Personal/Practice/StateManagemnt" component={StateManaGementComponent} ></Route> 
             <Route exact path="/Personal/Practice/" component={TestMainComponent} ></Route>
             <Route path="/Personal/Practice/Context" component={ContextComponent}></Route>     
             <Route path="/Personal/Practice/ComponentCommunication" component={CommunicationBetweenTwoComponent}></Route>
             <Route path="/Personal/Practice/LoopingThroughData" component={() => <ObjectLoopingComponent Listemployee={employees} />}></Route>
             <Route path="/Personal/Practice/ServiceCalling"  component={ListofPracticeComponent}></Route>
             <Route path="/Personal/Practice/AddMyPractice"  component={AddMyPractice}></Route>
             <Route path="/Personal/Practice/Forms"  component={FormEXComponent}></Route>
             <Route path="/Personal/Practice/LiftStateUp"  component={LiftingStateExampleCompo}></Route>
             <Route path="/Personal/Practice/LearnReactref"  component={LeranReactrefCompoent}></Route>
             <Route path="/Personal/Practice/PlayVideo"  component={PlayVideo}></Route>
             <Route path="/Personal/Practice/ForwardRef"  component={ForwardRefComponent}></Route>
             <Route path="/Personal/Practice/HODexample"  component={AdminDashboard}></Route>
             <Route component={InvalidPath}></Route>
        </Switch>     
        </div> 
        </div>    
    )
}
function TestMainComponent(){
    return (
        <h1>Welcome Ravi Test Your Practice</h1>
    )
}
export default TestComponent